<template lang="html">
    <b-field :label="label" :type="error?'is-danger':''" :message="error" :label-for="id">
        <b-input :type="type" :placeholder="holder" :value="value" @input="update" :size="size" :password-reveal="reveal" :autofocus="autofocus" :readonly="readonly" :disabled="disabled" :rounded="rounded" :min="min" :max="max" :maxlength="maxlength" :icon="icon" :name="name" :id="id"></b-input>
    </b-field>
</template>

<script>
import BField from "buefy/src/components/field/Field";
export default {
    components: {BField},
    data() {
        return {

        }
    },
    props: {
        type: {
            type: String,
            default: 'text'
        },
        id: String,
        label: String,
        name: String,
        holder: String,
        size: String,
        value: {

        },
        maxlength: Number|String,
        min: Number|String,
        max: Number|String,
        step: Number|String,
        error: Array,
        icon: String,
        iconAlign: {
            type: String,
            default: 'has-icon-right',
        },
        disabled: String|Boolean,
        autofocus: String|Boolean,
        readonly: String|Boolean,
        reveal: String|Boolean,
        rounded: String|Boolean
    },
    methods: {
        update(value) {
            this.$emit('input', value);
        },
    }
}
</script>

<style lang="css">
</style>
